import * as React from "react";
import { banner } from "./BookNowBanner.module.scss";
import BackgroundImage from "gatsby-background-image";
import { getImage } from "gatsby-plugin-image";
import { convertToBgImage } from "gbimage-bridge";

export const Banner: React.FC<any> = (props) => {
  const childImageSharp = props.image?.desktopImage;
  const _image = getImage(childImageSharp);
  const _bgImage = convertToBgImage(_image);
  return (
    <BackgroundImage {..._bgImage} preserveStackingContext className={banner}>
      {props.children}
    </BackgroundImage>
  );
};
